<div [ngStyle]="styleObject">
  <ng-container #fieldComponent></ng-container>
</div>
